import React from 'react'

interface HotelProps {
    height?: number
    width?: number
}

const Hotel: React.FC<HotelProps> = ({ height, width }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            fill='none'
            viewBox='0 0 20 20'
        >
            <path
                d='M1 16V4H2.5V12H9V5H16C16.8333 5 17.5417 5.29167 18.125 5.875C18.7083 6.45833 19 7.16667 19 8V16H17.5V13.5H2.5V16H1ZM3.97917 10.2708C3.49306 9.78472 3.25 9.19444 3.25 8.5C3.25 7.80556 3.49306 7.21528 3.97917 6.72917C4.46528 6.24306 5.05556 6 5.75 6C6.44444 6 7.03472 6.24306 7.52083 6.72917C8.00694 7.21528 8.25 7.80556 8.25 8.5C8.25 9.19444 8.00694 9.78472 7.52083 10.2708C7.03472 10.7569 6.44444 11 5.75 11C5.05556 11 4.46528 10.7569 3.97917 10.2708ZM10.5 12H17.5V8C17.5 7.5875 17.3531 7.23438 17.0594 6.94063C16.7656 6.64688 16.4125 6.5 16 6.5H10.5V12ZM6.45833 9.20833C6.65278 9.01389 6.75 8.77778 6.75 8.5C6.75 8.22222 6.65278 7.98611 6.45833 7.79167C6.26389 7.59722 6.02778 7.5 5.75 7.5C5.47222 7.5 5.23611 7.59722 5.04167 7.79167C4.84722 7.98611 4.75 8.22222 4.75 8.5C4.75 8.77778 4.84722 9.01389 5.04167 9.20833C5.23611 9.40278 5.47222 9.5 5.75 9.5C6.02778 9.5 6.26389 9.40278 6.45833 9.20833Z'
                fill='currentColor'
            />
        </svg>
    )
}

Hotel.defaultProps = {
    height: 20,
    width: 20
}

export default Hotel
